"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * UseCase incremental count is for Unique ID.
 */
var _UseCaseCount = 0;
/**
 * create new id
 */
exports.generateNewId = function () {
    _UseCaseCount++;
    return "UseCase__" + _UseCaseCount;
};
//# sourceMappingURL=UseCaseIdGenerator.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UseCaseIdGenerator.js
// module id = 195
// module chunks = 0